<template>
  <div v-if="isLoading" class="d-flex justify-content-center p-4 m-3">
    <b-spinner label="Loading..." variant="dark" />
  </div>

  <div v-else class="h-100">
    <badge-expired-link v-if="isExpired"></badge-expired-link>
    <b-col v-else class="conatiner__badge-detail p-0">
      <badge-detail-card :badge-info="badgeInfo"></badge-detail-card>
      <base-badge-detail :badge-info="badgeInfo"></base-badge-detail>
    </b-col>
  </div>
</template>
<script>
import CredentialLink from '@/models/CredentialLink';
import BaseBadgeDetail from '@/components/base-components/BaseBadgeDetail.vue';
import EvidenceSubmission from '@/models/EvidenceSubmission';
import LearningUnit from '@/models/LearningUnit';
import Post from '@/models/Post';
import PostResponse from '@/models/PostResponse';
import BadgeExpiredLink from './components/BadgeExpiredLink.vue';
import BadgeDetailCard from './components/BadgeDetailCard.vue';

export default {
  components: {
    BaseBadgeDetail,
    BadgeExpiredLink,
    BadgeDetailCard
  },

  data() {
    return {
      badgeInfo: null,
      isLoading: false,
      isExpired: false
    };
  },

  computed: {
    code() {
      return this.$route.params.code;
    }
  },

  mounted() {
    this.fetch();
  },

  methods: {
    async fetch() {
      if (!this.code) return;
      try {
        this.isLoading = true;
        const {
          response: { data = {} }
        } = await CredentialLink.api().fetchBadgeDetail(this.code);

        if (data && data.posts) {
          await Post.insert({ data: data.posts });
        }

        if (data && data.post_responses) {
          await PostResponse.insert({ data: data.post_responses });
        }

        if (data && data.evidence_submission) {
          await EvidenceSubmission.insert({ data: data.evidence_submission });
        }

        if (data && data.learning_unit) {
          await LearningUnit.insert({ data: data.learning_unit });
        }

        this.badgeInfo = {
          ...data
        };
      } catch (error) {
        console.error(error);
        this.isExpired = true;
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
<style lang="scss" scope>
.conatiner__badge-detail {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
